import React, { useState, useRef, useEffect } from 'react'
import './ImagesMosaic.css'

interface IProps {
  imageUrls: string[]
  id: string
}

const ImagesMosaic = (props: IProps) => {
  const mosaicRef = useRef<HTMLDivElement>(null)
  const [selectedImage, setSelectedImage] = useState<string>('')

  const handleImageClick = (imageUrl: string) => {
    setSelectedImage(imageUrl)
  }

  const closeModal = () => {
    setSelectedImage('')
  }

  useEffect(() => {
    const isClickOutsideOfMosaic = (event: Event) => {
      return (
        mosaicRef.current && !mosaicRef.current.contains(event.target as Node)
      )
    }

    const processOutsideClick = (event: Event) => {
      if (isClickOutsideOfMosaic(event)) {
        closeModal()
      }
    }

    const processEscapeKeyPress = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        processOutsideClick(e)
      }
    }

    window.addEventListener('click', processOutsideClick)
    window.addEventListener('keyup', processEscapeKeyPress)

    return () => {
      window.removeEventListener('click', processOutsideClick)
      window.removeEventListener('keyup', processOutsideClick)
    }
  }, [])

  return (
    <div id={props.id}>
      <div ref={mosaicRef} className="image-grid">
        {props.imageUrls.map((imageUrl, index) => (
          <div className="image-container" key={index}>
            <div className="image-index">{index + 1}</div>
            <img
              src={imageUrl}
              alt={`Image ${index}`}
              onClick={() => handleImageClick(imageUrl)}
            />
          </div>
        ))}
      </div>
      {selectedImage && (
        <div className="modal-background">
          <div
            className="modal"
            onClick={(e) => {
              e.stopPropagation()
            }}
          >
            <span className="close-button" onClick={closeModal}>
              &times;
            </span>
            <img src={selectedImage} alt="Selected Image" />
          </div>
        </div>
      )}
    </div>
  )
}

export default ImagesMosaic
